var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.47715 20 0 15.5229 0 10C0 4.47715 4.47715 0 10 0C15.5229 0 20 4.47715 20 10C20 15.5229 15.5229 20 10 20ZM14.1674 7.56052C14.6181 7.31402 14.7837 6.74877 14.5372 6.29803C14.2907 5.84727 13.7255 5.68169 13.2748 5.9282C11.5737 6.85847 10.1671 8.65386 9.2213 10.102C8.87181 10.6372 8.57321 11.1439 8.33433 11.5731C8.11148 11.3569 7.89077 11.1693 7.69338 11.0132C7.43507 10.809 7.20262 10.6479 7.03314 10.5369L6.74008 10.3549C6.29381 10.1004 5.7257 10.2558 5.47118 10.7021C5.21672 11.1483 5.37203 11.7162 5.81807 11.9709L6.01368 12.0932C6.14653 12.1802 6.33269 12.3091 6.53951 12.4727C6.96514 12.8091 7.42443 13.2502 7.71347 13.7335C7.89086 14.03 8.21805 14.2038 8.56307 14.1848C8.908 14.1658 9.21405 13.9568 9.35777 13.6427L9.44921 13.4516C9.51219 13.3229 9.60651 13.1346 9.7293 12.9027C9.97535 12.4379 10.3331 11.802 10.779 11.1193C11.6938 9.71861 12.8917 8.25814 14.1674 7.56052Z",
    fill: "#04954F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.c75fca2938388a1a82666c59c4caa8df.svg";
export { ForwardRef as ReactComponent };